import React from 'react';

import AdminCardImage from '../admin-card-fields/AdminCardImage/AdminCardImage';
import ContentChangeButton from '../../buttons/ContentChangeButton/ContentChangeButton';

import './AdminUserCard.css';

const AdminUserCard = ({
  user,
  currentUser,
  onEditClickHandler,
  onDeleteClickHandler,
  isButtonsDisabled,
  isDeleteButtonDisabled,
}) => {
  return (
    <div id='user-container'>
      <div id='user-user-wrapper'>
        <div className='user-details-container'>
          <div className='user-avatar-container'>
            <AdminCardImage
              size='small'
              shape='circle'
              img={user.imageUrl}
              alt='pro-evolution-user'
            />
          </div>
          <div className='username-email-container'>
            <div className='username-container'>
              <span>{user.userName}</span>
            </div>
            <div className='email-container'>
              <span>{user.email}</span>
            </div>
            <div className='isAdmin-container'>
              <span>{user.isAdmin ? 'Manager' : 'Associate'}</span>
            </div>
          </div>
        </div>
        <div className='LoggedIn-container'>
          <span>{user._id === currentUser._id ? 'You are logged in' : ''}</span>
        </div>
      </div>
      <div id='button-wrapper'>
        <ContentChangeButton
          size='large'
          iconType='edit'
          isDisabled={isButtonsDisabled}
          onClickHandler={() => onEditClickHandler(user)}
        />
        <ContentChangeButton
          size='large'
          iconType='delete'
          isDisabled={isButtonsDisabled || isDeleteButtonDisabled}
          onClickHandler={() => onDeleteClickHandler(user)}
        />
      </div>
    </div>
  );
};

export default AdminUserCard;
